<template>

  <div v-if="candidateId">
    <candidate
      :key="candidateId"
      @hideModal="hide()" 
      @deleted="hide()">
      </candidate>
  </div>
  
</template>

<script>
import Candidate from '@/components/Candidate/Candidate'

export default {
  name: 'CandidateObserver',
  components: {
    Candidate
  },
  data () {
    return {
    }
  },
  computed: {
    // candidateId é usado como key no component candidate para formçar a recontruçao sempre que for atualziado
    candidateId () {
      return this.$route.query.candidate_id
    },
    candidateJobId () {
      return this.$route.query.candidate_job_id
    },
    candidateOnlyThisJob () {
      return this.$route.query.candidate_only_this_job
    }
  },
  watch: {
    candidateJobId () {
      this.updateEnviroment()
    },
    candidateOnlyThisJob () {
      this.updateEnviroment()
    }
  },
  created () {
    this.updateEnviroment()
  },
  methods: {
    updateEnviroment () {
      this.$store.dispatch('setCandidateJobId', this.candidateJobId)
      this.$store.dispatch('setOnlyThisJob', this.candidateOnlyThisJob)
    },
    hide () {
      this.$openCandidateModal(null)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/CandidateObserver.vue